import React from 'react'
import RevenueChartY from './revenueChartY/RevenueChartY'
import ReveneueChartYPro from './revenueChartY/ReveneueChartYPro'
import RevenueChartAll from './revenueChartY/RevenueChartAll'

const RevenueCardY = () => {
    return (
        <div className='w-full text-sm font-color-4 flex flex-col'>
            <div className='flex justify-between items-center'>
                <p>Jahresumsatz</p>
                <button
                    className='hidden ml-4 px-3 py-2 bg-color-5 font-color-1 text-sm flex items-center shadow-sm border border-color-2 rounded-lg font-medium'>
                    Report anzeigen
                </button>
            </div>
            <RevenueChartAll/>
            <div className='flex items-center'>
                <div className='font-bold'><ReveneueChartYPro/></div>


            </div>
            <div className='flex justify-center items-center w-full py-2'>
                <RevenueChartY/>
            </div>
            <div className='flex items-center gap-2'>
                <div className='w-2 h-2 bg-color-1 rounded-full'/>
                <div className='font-color-6'>Umsatz</div>
                <div className='ml-2 w-2 h-2 bg-color-4 rounded-full'/>
                <div className='font-color-6'>Kosten</div>
            </div>
        </div>
    )
}

export default RevenueCardY